import styled from 'styled-components'

export const StyledTableWrapper = styled.div`
  max-height: 280px;
  overflow: auto;
  padding-bottom: 45px;
`
